export default __webpack_public_path__ + "static/how_it_works_3-d29c0a40239bb6010a81c0fe6a9243ca.png";